import { motion } from "framer-motion";

export const EASE = [0.21, 0.47, 0.32, 0.98];

export function Reveal({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ overline, title, description, testid }) {
  return (
    <div className="mb-14 max-w-3xl">
      <Reveal>
        <p className="mb-4 flex items-center gap-3 font-mono-tech text-xs font-bold uppercase tracking-[0.3em] text-[#F97316]">
          <span className="inline-block h-px w-10 bg-[#E65100]" aria-hidden="true" />
          {overline}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          data-testid={testid}
          className="font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-[#F8FAFC] sm:text-5xl lg:text-6xl"
        >
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p className="mt-6 text-base leading-relaxed text-[#94A3B8]">{description}</p>
        </Reveal>
      )}
    </div>
  );
}
